import { Component, Host, h, Prop, Watch, Element, State } from '@stencil/core';

export interface AhaProgressStep extends HTMLAhaProgressStepElement {}

@Component({
  tag: 'aha-progress-step',
  styleUrl: 'aha-progress-step.css',
  shadow: true,
})
export class AhaProgressStep {
  @Element() host!: HTMLAhaProgressStepElement;

  /** The individual step's position within the parent `<aha-progress-steps>` list. */
  @State() number?: number;

  /** Whether or not the step is the "current" step in the list. Note, you can also set the "step" attribute in the parent `<aha-progress-steps>` list and it will automatically set the "current" attribute for the specified step. */
  @Prop({ reflect: true }) current: boolean = false;
  @Watch('current')
  private async registerCurrent() {
    if (this.current) {
      const stepsElem = this.host.closest('aha-progress-steps');
      if (stepsElem) {
        stepsElem.step = (await stepsElem.getStepIndex(this.host)) + 1;
      }
    }
  }

  connectedCallback() {
    this.registerCurrent();
  }

  render() {
    return (
      <Host>
        <div id="line-container" hidden={!Boolean(this.number && this.number > 1)}>
          <div id="line"></div>
        </div>
        <div id="content">
          <div id="number">
            <div id="digits">{this.number}</div>
          </div>
          <div>
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }
}
